import {
  ClubMembership,
  ClubMembershipExtended,
  ColorOrderPaymentStatus,
  ColorOrderStatus,
  ColorPaymentStatus,
  ColorStayPlayStatus,
  ColorTeeTimeBookingStatus,
  DiscountCompany,
  ScoringFormatPointData,
  TeeBoxData,
} from './../data/mygolf.data';
import { ClubInfo } from './../data/club-course';
import { Injectable } from '@angular/core';
import { JsonService } from './../json-util';
import { ClubFlightService } from './../providers/club-flight-service/club-flight-service';
import * as globals from '../globals';
import { NavController, Platform } from '@ionic/angular';
import { CompetitionService } from 'src/providers/competition-service/competition-service';
import { MyGolfStorageService } from 'src/storage/mygolf-storage.service';
import { Location } from '@angular/common';
import { sha256 } from 'js-sha256';
import * as CryptoJS from 'crypto-js';
import { CustomSha1 } from 'src/custom/sha1';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class mygolfUtils {
  appAttribute: any;
  appAttributes: Array<any>;
  isClubSpecific: boolean;
  selClubMembership;
  homeClub: ClubInfo;
  clubId: number;
  settingsAttribute: any;

  playerClubMembership: Array<ClubMembershipExtended>;

  selectedClub: any;
  isWebParam: boolean;
  enableMGA: boolean = false;
  enableMakePaymentToClub: boolean = false;
  filteredByClub: any;
  groupClubs: Array<any>;
  clubGroupId: string;

  webPartner: boolean = false;
  webPartnerId: string;

  partnerAttributes: any;

  clubSpecific = new BehaviorSubject<any>({
    headerLogo: '',
    headerTitle: '',
    enableHeaderLogo: false,
    enableHeaderTitle: false,
    clubId: null,
  });

  // This is the observable you'll expose
  clubSpecific$: Observable<string> = this.clubSpecific.asObservable();
  constructor(
    private platform: Platform,
    private compService: CompetitionService,
    private storage: MyGolfStorageService,
    private navCtrl: NavController,
    private location: Location,
    private customSha1: CustomSha1,
    private flightService: ClubFlightService
  ) {
    const _param = this.platform.getQueryParam('param');
    if (globals?.appType === 'club' && globals?.clubId && !_param) {
      if (globals?.appClient === 'WAGC' || globals?.appClient?.includes('WAGC-')) {
      } else {
        this.clubId = globals?.clubId;
      }
    } else if (globals?.appType === 'club' && (globals?.clubId || _param)) {
      this.clubId = globals?.clubId;
    } else if (_param) {
      this.clubId = Number(_param);
    }
    console.debug('constructor clubId : ', this.clubId, _param);
    const enableMGA = this.platform.getQueryParam('enableMGA');
    const enableMakePaymentToClub = this.platform.getQueryParam('enableMakePaymentToClub');
    this.enableMGA = enableMGA === 'true';
    this.enableMakePaymentToClub = enableMakePaymentToClub === 'true';
    this.refreshTeeBoxData();
  }
  public numberWithCommas(x: any) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // public getUnique(arr, comp) {

  //     // store the comparison  values in array
  //     const unique = arr.map(e => e[comp])

  //         // store the indexes of the unique objects
  //         .map((e, i, final) => final.indexOf(e) === i && i)

  //         // eliminate the false indexes & return unique objects
  //         .filter((e) => arr[e]).map(e => arr[e]);

  //     return unique;
  // }

  getUnique(arr, comp) {
    const getter = (obj, path) => path.split('.').reduce((acc, part) => acc && acc[part], obj);

    const unique = arr
      .map((e, i) => ({ value: getter(e, comp), index: i }))
      .filter(
        (e, i, final) =>
          final.findIndex(t => JSON.stringify(t.value) === JSON.stringify(e.value)) === i
      )
      .map(e => arr[e.index]);

    return unique;
  }

  getUniqueMulti(arr, comp) {
    const getter = (obj, path) => path.split('.').reduce((acc, part) => acc && acc[part], obj);

    // convert single attribute into array
    const comps = Array.isArray(comp) ? comp : [comp];

    const unique = arr
      .map((e, i) => ({
        value: comps.map(c => getter(e, c)),
        index: i,
      }))
      .filter(
        (e, i, final) =>
          final.findIndex(t => JSON.stringify(t.value) === JSON.stringify(e.value)) === i
      )
      .map(e => arr[e.index]);

    return unique;
  }

  // public getAppAttribute(page: string) {
  //     if(!page) return;
  //     this.flightService.getAppAttributes()
  //         .subscribe((data: any) => {
  //
  //             if (data) {
  //                 data.filter((d) => {
  //                     return d.page === page
  //                 }).map((d) => {
  //                     this.appAttribute = d
  //                 });
  //
  //             }
  //         })
  // }

  public setClubSpecific(clubSpecific: boolean) {
    this.isClubSpecific = clubSpecific;
  }

  public getClubSpecific() {
    return this.isClubSpecific;
  }

  public setAppAttributes(appAttributes) {
    this.appAttributes = appAttributes;
  }

  public getAppAttribute() {
    return this.appAttributes;
  }

  public setClubMembership(selClubMembership) {
    console.debug('setting club membership', selClubMembership);
    this.selClubMembership = selClubMembership;
  }

  public getClubMembership() {
    console.debug('getting club membership', this.selClubMembership);
    return this.selClubMembership;
  }

  public setHomeClub(club) {
    this.homeClub = club;
  }
  public getHomeClub(): ClubInfo {
    return this.homeClub;
  }

  updateMyVariable(newValue: any) {
    this.clubSpecific.next(newValue);
  }

  getClubSpecificData() {
    return this.clubSpecific.asObservable();
  }
  public getClubSpecificHeader(attribute): any {
    if (!attribute) {
      return;
    }
    if (!this.selClubMembership && !this.isWebParam) {
      return;
    }
    let _clubSpecific = {
      headerLogo: '',
      headerTitle: '',
      enableHeaderLogo: false,
      enableHeaderTitle: false,
      clubId: null,
    };
    if (!this.isWebParam || this.selClubMembership) {
      this.appAttributes
        .filter(appAtt => appAtt.page === 'playerHome')
        .map(appAtt => {
          appAtt.clubSpecificThemes
            .filter(cc => this.selClubMembership.club.clubId === cc.clubId)
            .map(cc => {
              _clubSpecific = cc;
            });
        });
    }
    // else if(this.isWebParam && this.selectedClub) {
    //     this.appAttributes.filter((appAtt)=>{
    //         return appAtt.page === 'playerHome'
    //     }).map((appAtt)=>{
    //         appAtt.clubSpecificThemes.filter((cc)=>{
    //             return this.selectedClub.id === cc.clubId;
    //         }).map((cc)=>{
    //             _clubSpecific = cc;
    //         });
    //     })
    // }
    else if (this.isWebParam) {
      if (!this.selectedClub && this.clubId && this.appAttributes) {
        // (!_clubSpecific.clubId) &&

        this.appAttributes
          .filter(appAtt => appAtt.page === 'playerHome')
          .map(appAtt => {
            appAtt.clubSpecificThemes
              .filter(cc => Number(this.clubId) === Number(cc.clubId))
              .map(cc => {
                _clubSpecific = cc;
              });
          });
      } else if (this.selectedClub) {
        if (this.appAttributes) {
          this.appAttributes
            .filter(
              appAtt =>
                // console.debug("util selected club [0] : ",appAtt, appAtt.page)
                appAtt.page === 'playerHome'
            )
            .map(appAtt => {
              // console.debug("util inside [0]: ", appAtt.clubSpecificThemes)
              appAtt.clubSpecificThemes
                .filter(
                  cc =>
                    // console.debug("util inside [1]: ", cc, this.clubId, Number(cc.clubId) === Number(this.clubId))
                    Number(cc.clubId) === Number(this.clubId)
                )
                .map(cc => {
                  // _clubSpecific = cc;
                  _clubSpecific['headerLogo'] = globals.MygolfServer + '/' + cc.headerLogo;
                });
            });
        }
        // !_clubSpecific.clubId) &&
        if (this.selectedClub.clubLogo) {
          _clubSpecific['headerLogo'] = globals.MygolfServer + '/' + this.selectedClub.clubLogo;
        } else if (!this.selectedClub.clubLogo && this.selectedClub.clubThumbnail) {
          _clubSpecific['headerLogo'] = globals.MygolfServer + '/' + this.selectedClub.clubLogo;
        } else if (
          !this.selectedClub.clubLogo &&
          !this.selectedClub.clubThumbnail &&
          this.selectedClub.clubImage
        ) {
          _clubSpecific.headerLogo = this.selectedClub.clubImage;
        }
        _clubSpecific['headerTitle'] = this.selectedClub.name
          ? this.selectedClub.name
          : this.selectedClub.clubName;
        _clubSpecific['enableHeaderLogo'] = true;
        _clubSpecific['enableHeaderTitle'] = false;
      }
    }

    this.updateMyVariable(_clubSpecific);
    // console.debug('get whole club specific - util', _clubSpecific);
    // setTimeout(() =>{

    // console.debug('get club specific', _clubSpecific);
    switch (attribute) {
      case 'header-logo':
        // JsonService.deriveFullUrl(_clubSpecific, "headerLogo");
        let _headerLogo = '';
        if (this.isWebParam) {
          _headerLogo = _clubSpecific['headerLogo'];
        } else {
          _headerLogo = globals.MygolfServer + '/' + _clubSpecific['headerLogo'];
        }

        if (_headerLogo?.toLowerCase().includes(globals.MygolfServer.toLowerCase())) {
          return _headerLogo;
        } else {
          return globals.MygolfServer + '/' + _headerLogo;
        }
      // return _headerLogo;
      case 'header-title':
        return _clubSpecific['headerTitle'];
      case 'enableHeaderLogo':
        return _clubSpecific['enableHeaderLogo'];
      case 'enableHeaderTitle':
        return _clubSpecific['enableHeaderTitle'];
      case 'showWalletBalance':
        return _clubSpecific['showWalletBalance'];
      case 'showCreditBalance':
        let _showCreditBal: boolean = true;
        if (_clubSpecific['showCreditBalance'] !== undefined) {
          _showCreditBal = _clubSpecific['showCreditBalance'];
        } else if (
          _clubSpecific['showWalletBalance'] === undefined &&
          _clubSpecific['showCreditBalance'] === undefined
        ) {
          _showCreditBal = true;
        } else if (!_clubSpecific['showWalletBalance'] && !_clubSpecific['showCreditBalance']) {
          _showCreditBal = true;
        } else {
          _showCreditBal = _clubSpecific['showCreditBalance'];
        }
        return _showCreditBal; // _clubSpecific['showCreditBalance'];
      case 'all':
        return _clubSpecific;
    }
    // }, 1000)
  }

  public getMembershipType(attribute?: string) {
    if (!this.selClubMembership) {
      return 'Membership No.';
    }
    const _membershipType = {};
    this.appAttributes
      .filter(appAtt => appAtt.page === 'playerHome')
      .map(appAtt => {
        appAtt.membershipTypes
          .filter(mtype => mtype.id === this.selClubMembership.membershipType)
          .map(mtype => {
            _membershipType['id'] = mtype.id;
            if (mtype.id === 'F' || mtype.id === 'T') {
              _membershipType['name'] = 'Membership No.';
            } else {
              _membershipType['name'] = mtype.name;
            }
          });
      });
    if (attribute === 'id') {
      return _membershipType['id'];
    } else {
      return _membershipType['name'];
    }
  }

  public getClubLogo(attribute) {
    if (!this.appAttributes) {
      return;
    }
    if (!this.clubId) {
      return;
    }
    let _clubLogo;
    let _clubBanner;

    this.appAttributes
      .filter(appAtt => appAtt.page === 'playerHome')
      .map(appAtt => {
        appAtt.clubSpecificThemes
          .filter(theme => theme.clubId === this.clubId)
          .map(theme => {
            // JsonService.deriveFulImageURL(theme, "clubLogo")
            // JsonService.deriveFulImageURL(theme, "bannerLogo")
            _clubLogo = theme.clubLogo;
            _clubBanner = theme.bannerLogo; //clubBanner;
          });
      });

    switch (attribute) {
      case 'logo':
        return _clubLogo;
      case 'banner':
        return _clubBanner;
    }
  }

  public getSettingsAttribute() {
    if (!this.appAttributes) {
      return;
    }

    let _settingsAttribute;
    this.appAttributes
      .filter(appAtt => appAtt.page === 'appSettings')
      .map(appAtt => {
        _settingsAttribute = appAtt;
        this.settingsAttribute = appAtt;
      });

    return _settingsAttribute;
  }

  public getSpecificAppAttributePage(page: string) {
    if (!page) {
      return;
    }
    if (!this.appAttributes) {
      return;
    }
    let _appAttribute = null;
    this.appAttributes
      .filter(appAtt => appAtt.page === page)
      .map(appAtt => {
        _appAttribute = appAtt;
      });
    if (!_appAttribute) {
      return;
    } else {
      return _appAttribute;
    }
  }

  setPlayerClubMembership(playerClubMembership: Array<ClubMembershipExtended>) {
    this.playerClubMembership = playerClubMembership;
  }

  public getPlayerClubMembership() {
    return this.playerClubMembership;
  }

  setClubId(clubId: number) {
    // window.resizeTo(50, 50);

    // window.resizeBy(1300,450)// = 800;
    console.debug('set club id : ', clubId, this.clubId);
    this.clubId = clubId;
    if (this.isClubSpecific) {
      this.setCompClubId();
    }
  }

  async setCompClubId() {
    const searchCriteriaComp = this.compService.getSearch();
    if (globals.appType === 'club' && globals.appClient === null && globals.clubId) {
      searchCriteriaComp.clubId = globals.clubId;
    } else {
      searchCriteriaComp.clubId = this.clubId;
    } // this.selClubMembership.club.clubId;
    this.compService.setSearch(searchCriteriaComp);
    console.debug('comp service - set search', searchCriteriaComp);
  }

  public getClubId() {
    return this.clubId;
  }

  setSelectedClub(club: any) {
    console.debug('setSelectedClub', club);
    this.selectedClub = club;
  }

  getSelectedClub() {
    console.debug('getSelectedClub', this.selectedClub);
    return this.selectedClub;
  }

  setClubParam(param: boolean) {
    this.isWebParam = param;
  }

  getClubParam() {
    return this.isWebParam;
  }

  getColorBookingStatus(bookingStatus) {
    if (!bookingStatus) {
      return;
    }
    let _color = 'Black';
    for (const status in ColorTeeTimeBookingStatus) {
      if (status === bookingStatus.toUpperCase()) {
        _color = ColorTeeTimeBookingStatus[status];
      }
    }
    return _color;
  }

  getColorOrderStatus(orderStatus) {
    if (!orderStatus) {
      return;
    }
    let _color = 'Black';
    for (const status in ColorOrderStatus) {
      if (status === orderStatus.toUpperCase()) {
        _color = ColorOrderStatus[status];
      }
    }
    return _color;
  }

  getColorOrderPaymentStatus(paymentStatus) {
    if (!paymentStatus) {
      return;
    }
    let _color = 'Black';
    for (const status in ColorOrderPaymentStatus) {
      if (status === paymentStatus.toUpperCase()) {
        _color = ColorOrderPaymentStatus[status];
      }
    }
    return _color;
  }
  getColorStayPlayRequestStatus(requestStatus) {
    if (!requestStatus) {
      return;
    }
    let _color = 'Black';
    for (const status in ColorStayPlayStatus) {
      if (status === requestStatus.toUpperCase()) {
        _color = ColorStayPlayStatus[status];
      }
    }
    return _color;
  }
  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach(item => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  getMGALogo() {
    const _mgaLogo = globals.MygolfServer + '/document/logo/MGA_logo.png';
    return _mgaLogo;
  }

  isMGAEnable() {
    const _appAttribute = this.getSpecificAppAttributePage('externalNHS');
    if (_appAttribute && _appAttribute.enableMGA !== undefined) {
      this.enableMGA = _appAttribute.enableMGA;
    }
    return this.enableMGA;
  }

  isMakePaymentToClub() {
    const _appAttribute = this.getSpecificAppAttributePage('accountOptions');
    if (_appAttribute && _appAttribute.enableMakePaymentToClub !== undefined) {
      this.enableMakePaymentToClub = _appAttribute.enableMakePaymentToClub;
    }

    return this.enableMakePaymentToClub;
  }

  userType: string = null;
  setUserType(type: string) {
    this.userType = type;
  }

  getUserType() {
    return this.userType;
  }

  partnerInfo: DiscountCompany;
  setPartnerInfo(partner) {
    this.partnerInfo = partner;
  }

  getPartnerInfo() {
    return this.partnerInfo;
  }

  isBookingOverrideEnable() {
    let _bookingOverrideEnable: boolean = false;
    _bookingOverrideEnable =
      this.platform.getQueryParam('bookingOverrideEnable').toLowerCase() === 'true';
    return _bookingOverrideEnable;
  }

  persistClubTheme: any = null;
  setPersistClubTheme(type?: string) {
    if (type === 'communal') {
      this.persistClubTheme = type;
    } else if (type === null) {
      this.persistClubTheme = 'communal';
    } else if (type) {
      this.persistClubTheme = type;
    } else {
      this.persistClubTheme = null;
    }
  }

  isPersistClubTheme() {
    return this.persistClubTheme;
  }

  setGroupFilterClub(clubId: number) {
    this.filteredByClub = clubId;
  }

  getClubGroupInfo(attribute?: string) {
    if (!attribute) {
      return;
    }
    switch (attribute) {
      case 'clubGroupId':
        return this.clubGroupId;
      case 'groupClubs':
        return this.groupClubs;
    }
  }

  isMobileLayout() {
    return this.platform.width() < 768;
  }

  encodeKey(key: string, type?: string) {
    if (type) {
      return key;
    } else {
      return btoa(key);
    }
  }

  decodeKey(key: string, type?: string) {
    if (type) {
      return key;
    } else {
      return atob(key);
    }
  }

  getWebParams() {
    let _webPartnerId;
    if (
      this.decodeKey(this.platform.getQueryParam('d2ViUGFydG5lcklk')) &&
      this.decodeKey('d2ViUGFydG5lcklk') === 'webPartnerId'
    ) {
      _webPartnerId = this.decodeKey(this.platform.getQueryParam('d2ViUGFydG5lcklk'));
      if (_webPartnerId) {
        this.webPartnerId = _webPartnerId;
        this.webPartner = true;
      }
    }

    console.debug(
      'web partner id : ',
      _webPartnerId,
      this.platform.getQueryParam('d2ViUGFydG5lcklk'),
      this.decodeKey(this.platform.getQueryParam('d2ViUGFydG5lcklk'))
    );
  }

  public setPartnerAttributes(partnerAttributes) {
    this.partnerAttributes = partnerAttributes;
  }

  public getPartnerAttribute() {
    return this.partnerAttributes;
  }

  deriveScoringPoints(
    formatPoints: Array<ScoringFormatPointData>,
    parScore: number,
    grossScore: number,
    show: boolean = false
  ) {
    if (!formatPoints) {
      return;
    }
    if (parScore === undefined || parScore === null) {
      return;
    }
    if (grossScore === undefined || grossScore === null) {
      return;
    }
    formatPoints.sort((a, b) => {
      if (a.pointScore < b.pointScore) {
        return -1;
      } else if (a.pointScore > b.pointScore) {
        return 1;
      } else {
        return 0;
      }
    });
    // console.debug(" format points : ", formatPoints);
    const _bestScore = formatPoints[0].pointScore;
    const _worstScore = formatPoints[formatPoints.length - 1].pointScore;
    const _firstPoints = formatPoints[0].pointValue;
    const _lastPoints = formatPoints[formatPoints.length - 1].pointValue;
    const _adjustedScore = grossScore - parScore;
    let _points = formatPoints
      .filter(points => _adjustedScore === points.pointScore)
      .map(points => points.pointValue)
      .pop();

    if (_adjustedScore < _bestScore) {
      _points = _firstPoints;
    } else if (_adjustedScore > _worstScore) {
      _points = _lastPoints;
    }
    // if(show) console.debug("sorted scoring format points - adjusted : ",
    // _adjustedScore, ', best :', _bestScore, ', worst : ', _worstScore,
    // ', gross : ',grossScore, ', par : ',parScore);
    if (_adjustedScore <= _bestScore) {
      return _firstPoints;
    } else if (_adjustedScore > _worstScore) {
      return _lastPoints;
    }
    // else if(_adjustedScore > _bestScore) return _lastPoints;
    else {
      return _points;
    }
    // else return 0;
  }

  wrapReplaceNextWordAfter(originalMessage: string, wordToWrapAfter: string, htmlTag: string) {
    // originalMessage: string = "Already registered to play in the competition Various Tests TWO";
    // wordToWrapAfter: string = "competition";

    // Define your regex pattern
    const pattern: RegExp = new RegExp(`(${wordToWrapAfter}\\s+)(\\b.+\\b)`);

    // Replace the matched pattern with the wrapped version
    const modifiedMessage: string = originalMessage.replace(
      pattern,
      `$1<${htmlTag}>$2</${htmlTag}>`
    );
    return modifiedMessage;
  }

  separateWords(input: string): string {
    return input.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  setSearchPref(type: string, value: string) {
    if (!type) {
      return;
    }
    const _key = 'search.' + type;
    this.storage.setPreference(_key, value);
  }
  async getSearchPref(type: string) {
    if (!type) {
      return;
    }
    const _key = 'search.' + type;
    return this.storage.getPreference(_key);

    // await this.storage.getPreference('authToken').subscribe((value) => {
    //     token = value

    // })
  }

  getRange(n: number, start: number = 0): number[] {
    return Array(n)
      .fill(0)
      .map((_, index) => index + start);
    // return Array(n).fill(0).map((_, index) => index);
  }

  goToHome() {
    this.location.replaceState('tabs/player-home');
    this.navCtrl.navigateRoot('tabs/player-home');
  }

  capitalizeFirstLetter(str: string): string {
    str = str.toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  convertStringToImage(imageString: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image(); // Create a new Image object
      img.src = imageString; // Set the image source (Base64 or URL)

      // Resolve when the image is loaded
      img.onload = () => {
        resolve(img); // Return the image with width and height properties
      };

      // Handle errors in loading the image
      img.onerror = error => {
        reject(`Failed to load image: ${error}`);
      };
    });
  }

  getPref(key: string) {
    return this.storage.getPreference(key);
    //     let _value = null;
    //     await this.storage.getPreference(key).subscribe((value) => {
    //         _value = value
    //         console.debug("get pref :", key, value, _value)
    //     })
    //     console.debug("get pref : [1] ", key, _value)
    //     return _value;
    // //   return this.storage.getPreference(key);
  }

  setPref(key: string, value: any, remarks?: string) {
    console.debug('setting pref : ', key, value, remarks);
    this.storage.setPreference(key, value);
  }

  formatAmount(amount: number): string {
    // Handle zero or invalid amounts
    if (!amount || isNaN(amount)) {
      return '0';
    }

    // Constants for better readability
    const THOUSAND = 1000;
    const HUNDRED_K = 100000;
    const MILLION = 1000000;
    const BILLION = 1000000000;
    const TRILLION = 1000000000000;

    // Function to remove decimal .00
    const removeTrailingZeros = (num: number): string => num.toString().replace(/\.00$/, '');

    // Function to add commas to numbers
    const addCommas = (num: number): string =>
      num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    // //! FIRST ONE  Format based on conditions
    // if (amount >= BILLION && amount < TRILLION) {
    //   // Convert to billions (B)
    //   const formatted = amount / BILLION;
    //   return `${removeTrailingZeros(Number(formatted.toFixed(2)))} B`;
    // } else if (amount >= MILLION && amount < BILLION) {
    //   // Convert to millions (M)
    //   const formatted = amount / MILLION;
    //   return `${removeTrailingZeros(Number(formatted.toFixed(2)))} M`;
    // } else if (amount >= HUNDRED_K && amount < MILLION) {
    //   // Convert to hundreds of thousands (K)
    //   const formatted = amount / THOUSAND;
    //   return `${removeTrailingZeros(Number(formatted.toFixed(2)))} K`;
    // } else {
    //   // Regular formatting with commas
    //   return addCommas(amount);
    // }

    //! SECOND ONE
    if (amount >= TRILLION) {
      // Convert to billions with K
      const formatted = amount / BILLION;
      return `${addCommas(formatted).split('.')[0]} M`;
    } else if (amount >= BILLION) {
      // Convert to millions with K
      const formatted = amount / MILLION;
      return `${addCommas(formatted).split('.')[0]} K`;
    } else if (amount >= MILLION) {
      // Show in thousands with K
      const formatted = amount / THOUSAND;
      return `${addCommas(formatted).split('.')[0]} K`;
    } else if (amount >= HUNDRED_K) {
      // Show in thousands with K
      const formatted = amount / THOUSAND;
      return `${addCommas(formatted).split('.')[0]} K`;
    } else {
      // Regular formatting with commas
      return addCommas(amount);
    }
  }

  getNameInitials(fullName: string): string {
    if (!fullName) {
      return '';
    }

    // Remove extra spaces and split into words
    const nameParts = fullName.trim().split(/\s+/);

    // Initialize array to store valid initials
    const initials: string[] = [];

    // Patronymic indicators to skip
    const skipPatterns = [/^(A\/L)$/i, /^(A\/P)$/i, /^(bin)$/i, /^(binti)$/i];

    // Process each name part
    for (const part of nameParts) {
      // Skip if part matches any of the patterns to ignore
      if (skipPatterns.some(pattern => pattern.test(part))) {
        continue;
      }

      // Get first character if it's a valid alphabetic character
      const initial = part.charAt(0).toUpperCase();
      if (/[A-Z]/.test(initial)) {
        initials.push(initial);
      }

      // Break if we already have 2 initials
      if (initials.length === 2) {
        break;
      }
    }

    return initials.join('');
  }
  /**
   * Filters Array A to exclude items with IDs that exist in Array B
   * @param arrayA First array of objects
   * @param arrayB Second array of objects to check against
   * @returns Filtered array excluding items with matching IDs
   */
  filterExcludeExistingIds(arrayA: Array<any>, arrayB: Array<any>, compareKey: string): Array<any> {
    // Create a Set of values from Array B for O(1) lookup
    const existingValues = new Set(arrayB.map(item => item[compareKey]));

    // Filter Array A to exclude items whose values exist in the Set
    return arrayA.filter(item => !existingValues.has(item[compareKey]));
  }

  /**
   * @param type sha256, hmacsha-512, sha1
   * @param key
   * @param value
   */
  generateHashSignature(type: string, value: string, key?: string) {
    let _type = 'sha256';
    let hexHash = '';
    if (!type) {
      _type = 'sha256';
    } else {
      _type = type?.toLowerCase();
    }
    switch (_type) {
      case 'sha256':
        return sha256(value);
      case 'hmac-sha512':
        const hashA = CryptoJS.HmacSHA512(value, key);
        hexHash = hashA.toString(CryptoJS.enc.Hex);
        return hexHash;
      case 'hmacsha-512':
        const hashB = CryptoJS.HmacSHA512(value, key);
        hexHash = hashB.toString(CryptoJS.enc.Hex);
        return hexHash;
      case 'hmacsha512':
        const hashC = CryptoJS.HmacSHA512(value, key);
        hexHash = hashC.toString(CryptoJS.enc.Hex);
        return hexHash;
      case 'sha1':
        return this.customSha1.iPay88Signature(value);
    }
  }

  lightOrDark(color: string): 'light' | 'dark' {
    // tslint:disable-next-line:one-variable-per-declaration
    let r: number;
    let g: number;
    let b: number;

    // Check the format of the color, HEX or RGB
    if (color.match(/^rgb/)) {
      // If RGB --> Extract the red, green, blue values
      const match = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

      if (!match) {
        throw new Error('Invalid RGB color format');
      }

      r = parseInt(match[1], 10);
      g = parseInt(match[2], 10);
      b = parseInt(match[3], 10);
    } else {
      // If HEX --> Convert it to RGB
      if (color[0] === '#') {
        color = color.slice(1);
      }

      // Handle shorthand hex format (e.g. #abc)
      if (color.length === 3) {
        color = color
          .split('')
          .map(char => char + char)
          .join('');
      }

      if (color.length !== 6) {
        throw new Error('Invalid HEX color format');
      }

      r = parseInt(color.slice(0, 2), 16);
      g = parseInt(color.slice(2, 4), 16);
      b = parseInt(color.slice(4, 6), 16);
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    // Using the HSP value, determine whether the color is light or dark
    // return hsp > 165 ? 'light' : 'dark';
    return hsp > 150 ? 'light' : 'dark';
    // return hsp > 139.5 ? 'light' : 'dark';
  }

  // base64EncodeUnicode(str: string): string {
  // __btoa(str: string): string {
  //   return btoa(unescape(encodeURIComponent(str)));
  // }

  _btoa(str: string): string {
    return btoa(String.fromCharCode(...new TextEncoder().encode(str)));
  }

  getAppTypeClub() {
    return globals.appType === 'club';
  }

  filterFacilityBookings = new BehaviorSubject<any>({
    club: null,
    facilityType: 'All Facilities',
  });
  setFilterFacilityBookings(newValue) {
    this.filterFacilityBookings.next(newValue);
  }
  getFilterFacilityBookings() {
    return this.filterFacilityBookings.asObservable();
  }

  parseHtmlToText(htmlContent: string): string {
    const div = document.createElement('div');
    div.innerHTML = htmlContent;

    // Replace <br> tags with newline characters
    div.querySelectorAll('br').forEach(br => {
      br.replaceWith('\n');
    });

    return div.textContent || div.innerText || '';
  }

  getColorPaymentStatus(paymentStatus) {
    if (!paymentStatus) {
      return;
    }
    let _color = 'Black';
    for (const status in ColorPaymentStatus) {
      if (status === paymentStatus.toUpperCase()) {
        _color = ColorPaymentStatus[status];
      }
    }
    return _color;
  }

  parseStringItem(str: string) {
    const match = str.match(/^([A-Za-z]+)[-\s]?(\d+)?/);

    if (!match) {
      return { prefix: str, num: null };
    }

    return {
      prefix: match[1],
      num: match[2] ? Number(match[2]) : null,
    };
  }
  extractYoutubeVideoId(url: string): string {
    return url.split('v=')[1]?.split('&')[0];
  }

  teeBoxData = new BehaviorSubject<Array<TeeBoxData>>([]);

  getTeeBoxData() {
    return this.teeBoxData.asObservable();
  }

  setTeeBoxData(data: Array<TeeBoxData>) {
    this.teeBoxData.next(data);
  }
  refreshTeeBoxData() {
    this.flightService.getTeeBoxes().subscribe(teeBoxes => {
      this.setTeeBoxData(teeBoxes);
    });
  }
  getOrdinalSuffix(n: number): string {
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    const suffix = suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];
    return `${n}${suffix}`;
  }

  isUpdateAvailable(currentVersion: string, updateVersion: string): boolean {
    const current = currentVersion.split('.').map(Number);
    const update = updateVersion.split('.').map(Number);

    for (let i = 0; i < Math.max(current.length, update.length); i++) {
      const currentPart = current[i] || 0;
      const updatePart = update[i] || 0;

      if (currentPart < updatePart) return true;
      if (currentPart > updatePart) return false;
    }

    return false; // versions are equal
  }
  flattenObject(obj: any, parentKey = ''): any {
    const result: any = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const newKey = parentKey ? `${parentKey}.${key}` : key;

        if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
          // Recursively flatten nested objects
          const flattened = this.flattenObject(obj[key], newKey);
          Object.assign(result, flattened);
        } else {
          // Directly assign primitive values
          result[newKey] = obj[key];
        }
      }
    }

    return result;
  }
}
